import { Component, OnInit, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import { ErrCode } from '../../shared/models';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as fromRoot from '../../reducers';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggerService } from '../../core/logger.service';

@Component({
    selector: 'sync-link-consume-password',
    templateUrl: './link-consume-password.component.html'
})
export class LinkConsumePasswordComponent implements OnInit {

    @Output() password = new EventEmitter<string>();
    @Input() errcode: ErrCode;

    public spinner = false;
    public passwordfield: string;
    public linkPass: FormGroup;
    public sub: Subscription;
    //white label attrs
    public buttonPrimaryColor: string;
    public buttonTextColor: string;
    public whiteLabelLoaded: boolean;
    constructor(
        private fb: FormBuilder,
        private store: Store<fromRoot.State>,
        private sanitizer: DomSanitizer,
        private logger: LoggerService,
    ) { }

    ngOnInit() {
        this.sub = this.store.select(fromRoot.getLinkFileListState).subscribe((data) => {
            if (data.whitelabel_loaded) {
                this.buttonPrimaryColor = data.button_primary_color;
                this.buttonTextColor = data.button_text_color;
            }
        });
        this.spinner = false;
        this.linkPass = this.fb.group({
            passwordfield: ['', Validators.required]
        });
    }

    public setPassword() {
        this.spinner = true;
        this.password.emit(this.linkPass.get('passwordfield').value);
        this.spinner = false;
    }

    /**
     * this function updates css variables based on changes of this component's attributes
     */
    @HostBinding('attr.style')
    public get customColorsCss(): any {
        return this.sanitizer.bypassSecurityTrustStyle(`--buttonPrimaryColor: ${this.buttonPrimaryColor};
                                                        --buttonTextColor: ${this.buttonTextColor}`);
    }

}
